
export default function FinalCTA() {
  return (
    <section id="contact" className="relative bg-gradient-to-br from-[#0066FF] to-[#0052cc] py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M30 0l30 30-30 30L0 30z\' fill=\'%23ffffff\' fill-opacity=\'1\' fill-rule=\'evenodd\'/%3E%3C/svg%3E")',
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            Ready to Guarantee Your Growth?
          </h2>
          <p className="text-2xl text-white/90 font-light mb-8">
            Book a free strategy call. No pressure. No BS.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl text-center">
          <div className="mb-8">
            <div className="inline-flex items-center gap-3 bg-[#FF6B4A]/10 px-6 py-3 rounded-full mb-6">
              <i className="ri-calendar-check-line text-2xl text-[#FF6B4A]"></i>
              <span className="text-lg font-semibold text-gray-800">30-Minute Strategy Session</span>
            </div>
            
            <p className="text-gray-600 text-lg mb-8 max-w-2xl mx-auto">
              Let's discuss your business goals and create a custom plan to fill your calendar with high-quality leads.
            </p>
          </div>

          <a
            href="https://calendly.com/detailerx-agencys/detailerx-discovery-call"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block w-full md:w-auto bg-[#FF6B4A] text-white px-12 py-5 rounded-lg text-xl font-bold hover:bg-[#ff5a39] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Schedule Your Free Call Now
          </a>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 mt-8 pt-8 border-t border-gray-200">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <i className="ri-shield-check-line text-xl text-[#0066FF]"></i>
              <span>No Credit Card</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <i className="ri-calendar-check-line text-xl text-[#0066FF]"></i>
              <span>Free Strategy Session</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <i className="ri-time-line text-xl text-[#0066FF]"></i>
              <span>30-Min Call</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
